const SESSION_KEY = 'kf_token';
let _token = null;

export const tokenStore = {
  set(t) {
    _token = t;
    try { localStorage.setItem(SESSION_KEY, t); } catch { /* private mode */ }
  },
  get() {
    if (_token) return _token;
    // Restore after page refresh
    try {
      const stored = localStorage.getItem(SESSION_KEY);
      if (stored && !isTokenExpired(stored)) { _token = stored; return _token; }
      if (stored) localStorage.removeItem(SESSION_KEY); // expired – clear it
    } catch { /* private mode */ }
    return null;
  },
  clear() {
    _token = null;
    try { localStorage.removeItem(SESSION_KEY); } catch { /* private mode */ }
  },
};

export function decodeToken(token) {
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export function isTokenExpired(token) {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;
  return decoded.exp * 1000 < Date.now();
}
